import get from 'lodash/get';
import getMetaContent from '../util/getMetaContent';
import getPageId from '../util/getPageId';

// TODO: Move this back into a centralized file that can be updated independently of the project.
class Omniture {
  static getScriptBase() {
    if (window.location.hostname.indexOf('dev') > 1 || window.location.hostname.indexOf('localhost') > 1) {
      return '//apps-dev.bostonglobe.com';
    }
    return '//apps.bostonglobe.com';
  }

  load() {
    this.loadPromise = new Promise((resolve, reject) => {
      // The Omniture code creates window.s.version, so use that as a proxy to detect whether
      // Omniture is loaded.
      if (window.s && window.s.version) {
        resolve();
        return;
      }
      const scriptElement = document.createElement('script');
      scriptElement.src = `${Omniture.getScriptBase()}/common/js/omniture/s_code_bgcom.27.5.js`;
      scriptElement.onload = () => {
        resolve();
      };
      scriptElement.onerror = () => {
        reject();
      };
      document.body.appendChild(scriptElement);
    });
    return this.loadPromise;
  }

  /**
   *
   * @param {string} [section]
   * @param {string} [author]
   * @param {string} [pageName]
   * @param {string}  [projectName]
   * @returns {Promise<void>}
   */
  async setupTracking({
    section = '',
    author = '',
    pageName = '',
    projectName = '',
  }) {
    if (!this.loadPromise) {
      await this.load();
    } else {
      await this.loadPromise;
    }
    const pageId = getPageId({});

    const title = get(document.querySelector('title'), 'textContent', '');
    const titleWithoutGlobe = title.split('- The Boston Globe')[0].trim();

    window.s.pageName = pageName || `${section} | ${titleWithoutGlobe}`;
    window.s.channel = section;
    window.s.prop1 = `${section.toLowerCase()} | special reports${projectName ? ` | ${projectName.toLowerCase()}` : ''}`;
    window.s.prop6 = 'Article Page | Globe Story';
    window.s.prop41 = 'BostonGlobe.com';
    window.s.eVar41 = 'BostonGlobe.com';
    window.s.prop3 = author;
    window.s.prop67 = pageId;
    window.s.eVar67 = pageId;
    window.s.eVar73 = `${section.toLowerCase()} | special reports${projectName ? ` | ${projectName.toLowerCase()}` : ''}`;

    // TODO: Is this needed?
    const pageLayout = getMetaContent('pageLayout');
    if (pageLayout) {
      window.s.prop4 = pageLayout;
    }

    // The actual call of the page load is now deferred to the meter.
  }
}

export default Omniture;
